module.exports = __webpack_public_path__ + "static/media/infinity.b21df76a.jpeg";